import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "remote-monitoring-item-tile" }
const _hoisted_2 = { class: "remote-monitoring-item-tile__reaction" }
const _hoisted_3 = { class: "remote-monitoring-item-tile__confidence" }
const _hoisted_4 = { class: "remote-monitoring-item-tile__user heading-m" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "remote-monitoring-item__watch-lists" }
const _hoisted_7 = { class: "remote-monitoring-item-tile__hint-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Acknowledge = _resolveComponent("Acknowledge")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!
  const _component_NHint = _resolveComponent("NHint")!

  return (_openBlock(), _createBlock(_component_NHint, {
    class: "remote-monitoring-item-tile__hint",
    placement: "top",
    "delay-hidden": 0,
    "delay-visible": 400
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$filters.formatDateTime(_ctx.item.created_date)), 1),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.shortString(_ctx.item.camera, 36)), 1),
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.shortString(_ctx.item.puppet_id, 36)), 1),
        _hoisted_10,
        _createTextVNode(" \"" + _toDisplayString(_ctx.reasons) + "\" ", 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Acknowledge, {
            item: _ctx.item,
            onAction: _ctx.acknowledgeHandler,
            disabled: _ctx.item.acknowledged || !_ctx.acknowledgeAllowed
          }, null, 8, ["item", "onAction", "disabled"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.itemContainerClasses),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('action', 'show-item')))
        }, [
          _createVNode(_component_NThumbnail, {
            actions: _ctx.thumbnailActions,
            defaultAction: _ctx.defaultAction,
            "model-value": _ctx.thumbnail,
            onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select'))),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onAction: _cache[2] || (_cache[2] = (v) => _ctx.$emit('action', v))
          }, null, 8, ["actions", "defaultAction", "model-value"]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.item.confidence)
              ? (_openBlock(), _createBlock(_component_Confidence, {
                  key: 0,
                  value: _ctx.item.confidence,
                  objects: _ctx.objectsType
                }, null, 8, ["value", "objects"]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.cardContainerClasses, "remote-monitoring-item-tile__card"]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.card && _ctx.navigateToCard()))
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.item.card)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formattedMatchedCard), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_WatchListsGroup, {
              type: "short",
              items: _ctx.card?.watch_lists,
              style: {"width":"160px"},
              "text-color": _ctx.watchListsColor
            }, null, 8, ["items", "text-color"])
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}